import { createRoot } from 'react-dom/client'
import { DaraAppShell } from './dara-app-shell.jsx';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<DaraAppShell />);
